import React from 'react';

const PageContainer = ({ children }) => {
	return <div className="mt-16 md:mt-32 w-11/12 mx-auto max-w-3xl pb-80 ">{children}</div>;
};

export default PageContainer;
